export const ACCOUNT_REQUEST_STATUS_CODE = {
  NEW: '1',
  MODIFIED: '2',
  SUBMITTED: '3',
  UNKNOWN: '0',
};

export const ACCOUNT_REQUEST_STATUS_LABEL = {
  NEW: 'New',
  MODIFIED: 'Modified',
  SUBMITTED: 'Submitted',
  UNKNOWN: 'Unknown',
};

export const getPersonalAccountRequestStatusLabel = (code) => {
  const status = Object.keys(ACCOUNT_REQUEST_STATUS_CODE)
    .find(key => ACCOUNT_REQUEST_STATUS_CODE[key] === code);
  return status ? ACCOUNT_REQUEST_STATUS_LABEL[status] : ACCOUNT_REQUEST_STATUS_LABEL.UNKNOWN;
};
